<template>
  <div>
    <b-table :data="documents" :bordered="true" :striped="true" :hoverable="true">
      <template v-slot="props">
        <b-table-column field="file_name" label="File Name">{{ props.row.file_name }}</b-table-column>
        <b-table-column field="document_name" label="Image"><img class="image is-64x64" :src="props.row.file_url" :alt="props.row.file_name"></b-table-column>
        <b-table-column field="actions" label="Actions">
          <button class="button" @click="isCardModalActive = true">View</button>
          <a :href="props.row.file_url"><button class="button has-margin-left-10">Download</button></a>
        </b-table-column>
         <b-modal :active.sync="isCardModalActive" :width="640" scroll="keep">
            <div class="card">
                <div class="card-image">
                    <figure class="image is-4by3">
                        <img :src="props.row.file_url" alt="Image">
                    </figure>
                </div>
                <div class="card-content">
                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-48x48">
                                <img :src="props.row.file_url" alt="Image">
                            </figure>
                        </div>
                        <div class="media-content">
                            <p class="title is-5">Document Name: {{props.row.file_name}}</p>
                            <p class="title is-5">Shipping Application Reference Number: {{ref_no}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
      </template>

      <template v-slot:empty>
        <div class="has-text-grey has-text-centered has-padding-30 has-margin-0 is-size-4">
          <div>No additional documents uploaded.</div>
        </div>
      </template>
    </b-table>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>

export default {
  name: "UploadedDocuments",

  props: {
    documents: { type: Array, required: true },
    ref_no: {type: String, required: false}
  },

  data() {
    return {
      isCardModalActive: false,
      isLoading: false

    };
  },

  methods: {
  
  }
};
</script>
